export default __webpack_public_path__ + "static/media/m-link-youtube.3a34ed21.svg";